// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qgZQbpRlYMGk0KUV4xpy{color:var(--content-primary-primary);margin:20px auto 4px;font-size:14px;font-weight:500}.IZ3FELy3T02RpRe8RDHI{color:var(--content-primary-tertiary);margin-top:4px;margin-bottom:21px;font-size:13px;font-weight:400}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerText": `qgZQbpRlYMGk0KUV4xpy`,
	"additionText": `IZ3FELy3T02RpRe8RDHI`
};
export default ___CSS_LOADER_EXPORT___;
